import React from 'react';

const UploadIcon: React.FC = (): React.ReactElement => {
  return (
    <>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g id="Upload">
          <path
            id="Combined Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.25 6.25L18.7322 6.76777L11.6612 13.8388L13.4289 15.6066L19.25 9.78553V27.5H21.75V9.78553L27.5711 15.6066L29.3388 13.8388L22.2678 6.76777L21.75 6.25L20.5 5L19.25 6.25ZM5.5 32.5V25H3V35H38V25H35.5V32.5H5.5Z"
            fill="#F1F1F1"
          />
        </g>
      </svg>
    </>
  );
};

export default UploadIcon;
